const ABORT_TIMEOUT = 2000
const KEY_ENTER = 13
const KEY_TAB = 9
const KEY_SPACE = 32
const delimiterKeys = [KEY_ENTER, KEY_TAB, KEY_SPACE]
let handlers = []
let isListeningToKeyboard = false
let abortTimeout = null
let inputBuffer = ''

function listen(handler) {
  handlers = [...handlers, handler]
  if (!isListeningToKeyboard) {
    isListeningToKeyboard = true
    window.addEventListener('keydown', handleKeyboardEvent)
  }
}

function unlisten(handler) {
  handlers = handlers.filter((cur) => cur !== handler)
  if (isListeningToKeyboard) {
    isListeningToKeyboard = false
    window.removeEventListener('keydown', handleKeyboardEvent)
  }
}

function handleKeyboardEvent(event) {
  const inputElementTypes = ['input', 'textarea']

  const currentElement = event.composedPath()[0]
  const currentElementType = currentElement.nodeName.toLowerCase()

  if (!inputElementTypes.includes(currentElementType)) {
    const { key, keyCode } = event
    if (key.length === 1) {
      inputBuffer += key
    }
    startAbortTimeout()
    if (delimiterKeys.includes(keyCode)) {
      event.preventDefault()
      handlers.forEach((handler) =>
        handler({
          data: {
            barcode: inputBuffer,
          },
        })
      )
      clear()
      stopAbortTimeout()
    }
  }
}

function clear() {
  inputBuffer = ''
}

function startAbortTimeout() {
  if (abortTimeout !== null) {
    stopAbortTimeout()
  }
  abortTimeout = setTimeout(clear, ABORT_TIMEOUT)
}

function stopAbortTimeout() {
  if (abortTimeout !== null) {
    clearTimeout(abortTimeout)
    abortTimeout = null
  }
}

export default { listen, unlisten }
